"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAvailabilityEvents = void 0;
var lodash_1 = require("lodash");
var handleAvailabilityEvents = function (mutation, state) {
    var cruise = (0, lodash_1.get)(state, 'searching.cruises.current', {
        cabinCategories: [],
    });
    var availableCabinCategories = (0, lodash_1.filter)(cruise.cabinCategories, [
        'available',
        true,
    ]);
    var availableCabinCategoryNames = (0, lodash_1.uniq)((0, lodash_1.map)(availableCabinCategories, 'name'));
    var priceModels = (0, lodash_1.uniq)((0, lodash_1.map)(availableCabinCategories, 'priceModel'));
    var events = [
        {
            event: 'cabinCategoryAvailability',
            cabinCategoryAvailability: availableCabinCategoryNames.join('/'),
        },
        {
            event: 'priceCategoryAvailability',
            priceCategoryAvailability: priceModels.join('/'),
        },
    ];
    return events;
};
exports.handleAvailabilityEvents = handleAvailabilityEvents;
//# sourceMappingURL=availability_events.js.map